const KEY = "thrive.recentSearches";
const MAX = 10;

export function getRecent(): string[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function pushRecent(term: string): void {
  const trimmed = term.trim();
  if (!trimmed) return;
  try {
    const list = getRecent().filter((t) => t !== trimmed);
    list.unshift(trimmed);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {}
}

export function removeRecent(term: string): void {
  try {
    const list = getRecent().filter((t) => t !== term);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {}
}

export function clearRecent(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}
